export default __webpack_public_path__ + "static/home-newton-a0a0f2d95bbd65a24960aa40325974be.png";